<template>
  <form class="registration-form form-common-style" id="registration-form">
    <!-- Form elements (array of elements, text, email, dropdown etc.) -->
    <form-component :field="field" ref="components" v-for="(field, index) in detailElements" :key="field.name"/>

    <!-- Terms of service (array of checkboxes) -->
    <terms-of-service ref="terms" :fieldData="{ required: true }" />
    <checkbox :fieldData="newsletterField" />
    
    <p class="help--text" v-t="'register.help_text'"/>
    <button
      class="form-page__submit btn--inverted"
      @click="submitForm"
      type="submit"
      v-t="'register.submit'"/>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import FormComponent from "./FormComponent.vue";
import TermsOfService from "./TermsOfService.vue";
import Checkbox from "./Checkbox.vue";

export default {
  name: "registration-form",
  props: {
    formSchema: {
      type: Array,
      required: true,
    },
  },
  components: {
    FormComponent,
    TermsOfService,
    Checkbox,
  },
  methods: {
    goToSuccess() {
      this.$router.push({ name: "registration-success", params: { locale: this.$i18n.locale } });
    },
    async submitForm(e) {
      e.preventDefault();

      let validation = true;
      this.$refs.components.forEach((item) => {
        item.validateField();
        if (!item.valid) {
          validation = false;
        }
      });

      this.$refs.terms.validateField();
      if (!this.$refs.terms.valid) {
        validation = false;
      }


      if (!validation) {
        // Logic to scroll to first error
        let firstErrorFound = null;

        this.$refs.components.some((item) => {
          if(!item.valid) {
            firstErrorFound = item;
            return true;
          }
        });

        if(firstErrorFound) {
          window.scrollTo({
            top: firstErrorFound.$el.offsetTop,
            left: 0,
            behavior: 'smooth'
          });
        }
        // End of scroll to error logic

        return;
      }
      let result = await this.submitRegistrationData();

      if (result) {
        this.$router.push({ name: "registration-success", params: { locale: this.$i18n.locale } });
      }
    },
    ...mapActions(["submitRegistrationData", "updateLoading"]),
  },
  computed: {
    newsletterField() {
      return {
        name: "Newsletter",
        crm_id: "WK_eNews",
        title: this.$t("register.newsletter"),
      }
    },
    detailElements() {
      let exclusionArray = ["webform_terms_of_service", "webform_actions"];

      return this.formSchema.filter(
        (field) => !exclusionArray.includes(field.type)
      );
    },
    termsOfServiceElements() {
      return this.formSchema.filter(
        (field) => field.type == "webform_terms_of_service"
      );
    },
    actionElements() {
      return this.formSchema.filter((field) => field.type == "webform_actions");
    },
  },
};
</script>